import { RECAPTCHA_SITE_KEY } from '../config/env';

const RECAPTCHA_SCRIPT_ID = 'google-recaptcha-v3';
const SITE_KEY = RECAPTCHA_SITE_KEY;

let scriptPromise = null;

function loadRecaptchaScript() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('reCAPTCHA indisponible hors navigateur'));
  }

  if (!SITE_KEY) {
    return Promise.reject(
      new Error('REACT_APP_RECAPTCHA_SITE_KEY manquante'),
    );
  }

  if (window.grecaptcha?.execute) {
    return Promise.resolve(window.grecaptcha);
  }

  if (scriptPromise) {
    return scriptPromise;
  }

  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById(RECAPTCHA_SCRIPT_ID);
    if (existing) {
      existing.addEventListener('load', () => {
        window.grecaptcha.ready(() => resolve(window.grecaptcha));
      });
      existing.addEventListener('error', () =>
        reject(new Error('Échec chargement reCAPTCHA')),
      );
      return;
    }

    const script = document.createElement('script');
    script.id = RECAPTCHA_SCRIPT_ID;
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      if (!window.grecaptcha) {
        reject(new Error('grecaptcha indisponible'));
        return;
      }
      window.grecaptcha.ready(() => resolve(window.grecaptcha));
    };
    script.onerror = () => reject(new Error('Échec chargement reCAPTCHA'));
    document.head.appendChild(script);
  });

  return scriptPromise;
}

/**
 * Précharge le script reCAPTCHA.
 * Le badge Google est masqué via CSS (.grecaptcha-badge) ;
 * le texte légal doit rester visible sur les formulaires concernés.
 * À appeler au montage des pages avec formulaires publics.
 */
export function preloadRecaptcha() {
  return loadRecaptchaScript().catch((err) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[reCAPTCHA]', err?.message || err);
    }
  });
}

/**
 * Génère un token reCAPTCHA v3 pour une action donnée.
 * @param {string} action ex: 'faq_submit' | 'newsletter_subscribe'
 * @returns {Promise<string>}
 */
export async function getRecaptchaToken(action) {
  const grecaptcha = await loadRecaptchaScript();
  const token = await grecaptcha.execute(SITE_KEY, { action });
  if (!token) {
    throw new Error('Token reCAPTCHA vide');
  }
  return token;
}
